// extracted by mini-css-extract-plugin
export default {"resultTotal":"ResultTotal_resultTotal__mTMqO"};